/*!
* Copyright (c) 2018-present Cyclope.ai
* LICENSE file is in the root directory of this source tree.
* */
import * as ModelsFromStore  from '@apps-store/models';
import * as EnumsFromStore from '@apps-store/enums';
import { Dispatch } from 'redux';

import * as Utils from '@root-utils/index';

/**
 * @function DelayedActionSuccess  - 
 * @return { object } payload
 * @returns { string }  type
 * @param { any } 
 */
export function DelayedActionSuccess(data:any): ModelsFromStore.DelayedActionSuccess {

    return {
        
        payload:{

            data,
            loading: false,
            

        },

        type :EnumsFromStore.DelayedTypes.DELAYED_SUCCESS

    }
}

/**
 * @function DelayedActionFail  - 
 * @return { object }   payload
 * @returns { string }  type
 * @param { any } 
 */
export function DelayedActionFail(errors: any): ModelsFromStore.DelayedActionFail {

    return {
        payload:{

            error: errors  ,
            loading: false,
            
        },

        type :EnumsFromStore.DelayedTypes.DELAYED_FAIL

    }
}
/**
 * @function DelayedActionInProgress  - 
 * @return { object }   payload
 * @returns { string }  type
 * @param {  } 
 */
export function DelayedActionInProgress(): ModelsFromStore.DelayedActionInProgress{

    return {
        payload:{

         
            loading: true,
            
        },

        type :EnumsFromStore.DelayedTypes.DELAYED_INPROGRESS

    }
}




// CONSTRUCTEUR
/**
 * @function DelayedActionCreator 
 * @param {  } 
 * @return {Promise<any>}  Promise
 */
export function DelayedActionCreator(index: number):(dispatch: Dispatch<any>, {}) => Promise<any>{
 
    return  async (dispatch: Dispatch<any>) => {

        dispatch(DelayedActionInProgress());

        await Utils.delayedTimes(index)
            .then((res: any) => {
                if( res.ok ){ res.json().then( (data: any) => dispatch(DelayedActionSuccess(data)))     
                }else{ dispatch(DelayedActionFail("server error has occurred with HTTP status ("+res.status+ ")" ))}
            })
            .catch( (error : any) => dispatch(DelayedActionFail(error)))  
    }
    
}  



// WEBPACK FOOTER //
// ./src/apps/store/action-creator/delayed/index.ts